import { useMemo, useState } from 'react';
import { TaskResponse } from '../../../../@types/crs/task';
import TaskList, { GridState } from './TaskList';
import useTenantConfigData from 'src/careflow/ph-core/multi-tenant/tenant/hook/useTenantConfigData';
import { PermissionsProvider } from '../../../ph-core/admin/permissions/context/PermissionsContext';
import { TaskPermissions } from '../../../helpers/types';
import { checkAclValidation } from 'src/careflow/ph-core/admin/permissions/util/permission.utils';
import crsAcls from 'src/careflow/ph-core/admin/permissions/util/crs/crsAcls';

const initialGridState: GridState = {
  page: 1,
  rowsPerPage: 5,
  orderBy: 'periodEnd',
  orderDirection: 'asc',
  search: '',
  statusFilter: [],
  typeFilter: [],
  ownerFilter: [],
};

const TaskListContainer = () => {
  const { componentsData } = useTenantConfigData();
  const { filters: taskConfigFilters } = componentsData?.task ?? {};

  const initialValuesGridState = useMemo(
    () => ({
      ...initialGridState,
      statusFilter: taskConfigFilters?.status ? taskConfigFilters?.status : [],
    }),
    [taskConfigFilters]
  );

  const [list, setList] = useState<TaskResponse[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');
  const [totalItems, setTotalItems] = useState<number>(0);
  const [startDate, setStartDate] = useState<any>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const taskPermissions: TaskPermissions = useMemo(
    () => ({
      isAllowedToAdd: checkAclValidation({ acls: [crsAcls.CRS.PATIENT.TASKS.ADD] }),
      isAllowedToEdit: checkAclValidation({ acls: [crsAcls.CRS.PATIENT.TASKS.EDIT] }),
      notes: {
        isAllowedToView: checkAclValidation({ acls: [crsAcls.CRS.PATIENT.TASKS.NOTES.VIEW] }),
        isAllowedToAdd: checkAclValidation({ acls: [crsAcls.CRS.PATIENT.TASKS.NOTES.ADD] }),
      },
      isAllowedToAssignProgram: checkAclValidation({
        acls: [crsAcls.CRS.PATIENT.TASKS.HANDLER.ASSIGN_PROGRAM],
      }),
      isAllowedReferralInternal: checkAclValidation({
        acls: [crsAcls.CRS.PATIENT.TASKS.HANDLER.REFERRAL_INTERNAL],
      }),
      isAllowedReferralExternal: checkAclValidation({
        acls: [crsAcls.CRS.PATIENT.TASKS.HANDLER.REFERRAL_EXTERNAL],
      }),
      isAllowedAppointmentScheduling: checkAclValidation({
        acls: [crsAcls.CRS.PATIENT.TASKS.HANDLER.APPOINTMENT],
      }),
      isAllowedWarmHandoff: checkAclValidation({
        acls: [crsAcls.CRS.PATIENT.TASKS.HANDLER.WARM_HANDOFF],
      }),
    }),
    []
  );

  return (
    <PermissionsProvider permissions={taskPermissions ?? null}>
      <TaskList
        includeBreadcrumbs={true}
        list={list}
        setList={setList}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        totalItems={totalItems}
        setTotalItems={setTotalItems}
        startDate={startDate}
        setStartDate={setStartDate}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        initialGridState={initialValuesGridState}
        permissions={taskPermissions}
      />
    </PermissionsProvider>
  );
};

export default TaskListContainer;
